import * as React from "react";
import { Checkbox } from "antd";
import styled from "styled-components";
import { storage } from "@/util";

import { NORMALSETTINGKEY } from "@/config/const";
const Container = styled.div`
  padding: 30px 20px 0 10px;
  .item {
    padding: 10px 0;
  }
`;

interface SetItem {
  [k: string]: boolean;
}

const NormalSetting: React.FunctionComponent = () => {
  const [settings, setSettings] = React.useState<SetItem>({});

  React.useEffect(() => {
    const settingsItem = (storage.get(NORMALSETTINGKEY) || {}) as SetItem;
    setSettings(settingsItem);
  }, []);

  const vChange = (k: string, c: boolean) => {
    const item = { ...settings, [k]: c };
    setSettings(item);
    storage.save(NORMALSETTINGKEY, item);
  };

  const settingsConfig = [
    { key: "video", name: "Камер асаах" },
    { key: "mic", name: "Микрофон асаах" },
    { key: "audio", name: "Спикер асаах" },
    { key: "showspeaker", name: "Ярьж байгаа хүнийг харуулах" },
    { key: "showtime", name: "Хугацаа харуулах" },
  ];

  return (
    <Container>
      {settingsConfig.map((item) => (
        <div className="item" key={item.key}>
          <Checkbox
            checked={settings[item.key] || false}
            onChange={(t) => vChange(item.key, t.target.checked)}
          >
            {item.name}
          </Checkbox>
        </div>
      ))}
    </Container>
  );
};

export default NormalSetting;
